module.exports = __webpack_public_path__ + "img/log_in_icon_dashboard.115d18e2.svg";